var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-col',{staticClass:"header-container"},[_c('h2',{style:({'background-color':_vm.bgColor}),attrs:{"id":_vm.headerId}},[_vm._v(_vm._s(_vm.label))])])
}
var staticRenderFns = []

export { render, staticRenderFns }